import React from 'react';
import '../styles/Discordbot.css';
import j4flogo from '../assets/j4f_logo.png';

const Discordbot = () => {
  const serviziBot = [
    {
      titolo: "Collaborazioni Just4Fun",
      descrizione: "Servizio per le collaborazioni con la community Just4Fun ITA, nello specifico...",
      prezzo: "Gratis",
      icona: "🤝"
    },
    {
      titolo: "Servizi Youtube/Twitch",
      descrizione: "Notifiche automatiche e personalizzate per video e live direttamente sul tuo server.",
      prezzo: "da 1,99€",
      icona: "📢"
    },
    {
      titolo: "Comandi Slash",
      descrizione: "Abilitazione a comandi slash base o personalizzati per gestire il tuo server.",
      prezzo: "da 0,99€",
      icona: "🛠️"
    },
    {
      titolo: "Benvenuto Personalizzato",
      descrizione: "Messaggi di benvenuto unici per i nuovi utenti che entrano nel tuo server.",
      prezzo: "1,99€",
      icona: "✨"
    }
  ];

  return (
    <div className="bot-page">
      <div className="bot-container">
        {/* Header con Logo */}
        <header className="bot-header">
          <img src={j4flogo} alt="Just4Fun APP" className="bot-main-logo" />
          <h1 className="titolo-principale">Just4Fun APP</h1>
          <p className="descrizione-hero">
            Il bot multifunzione progettato per i server discord delle Community. 
            Gestisci notifiche, comandi e automazioni con un unico strumento.
          </p>
          <div className="hero-buttons">
            <a href="https://discordapp.just4fun.it" target="_blank" className="btn-custom-discord">Invita il Bot</a>
            <a href="https://discord.just4fun.it" target="_blank" className="btn-custom-primary">Supporto</a>
          </div>
        </header>

        {/* Sezione Servizi (Vetrina Shop) */}
        <section className="bot-shop-section">
          <h2 className="titolo-sezione">Servizi ed Estensioni</h2>
          <div className="bot-features-grid">
            {serviziBot.map((servizio, index) => (
              <div key={index} className="bot-feature-card">
                <div className="bot-feature-icon">{servizio.icona}</div>
                <h3>{servizio.titolo}</h3>
                <p>{servizio.descrizione}</p>
                <span className="bot-price-tag">{servizio.prezzo}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Footer Informativo */}
        <footer className="bot-footer-info">
          <div className="info-box">
            <p>
              Tutti i servizi elencati sono acquistabili e gestibili unicamente tramite lo <strong>Shop integrato</strong> dal profilo dell'APP.
            </p>
            <a href="https://discord.just4fun.it" target="_blank"className="discord-shop-link">
              Apri lo Shop su Discord
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Discordbot;